import * as THREE from "three";
import { getSceneState } from "../stores/sceneStore";
import type {
  GeomGizmoTarget,
  MultiGeomPositionSnapshot,
  SceneBodyLookup,
} from "./positionGizmoTypes";

export function captureMultiGeomPositionSnapshots(
  targets: GeomGizmoTarget[]
): MultiGeomPositionSnapshot[] {
  const sceneState = getSceneState();
  const seen = new Set<string>();
  const bodyUuids = new Set<string>();
  const snapshots: MultiGeomPositionSnapshot[] = [];

  for (const target of targets || []) {
    if (!target?.bodyUuid || !target?.geomId) continue;
    const key = `${target.bodyUuid}:${target.geomId}`;
    if (seen.has(key)) continue;
    seen.add(key);
    const body = (sceneState.bodies as SceneBodyLookup | undefined)?.[target.bodyUuid];
    const geom = Array.isArray(body?.geoms)
      ? body.geoms.find((entry) => String(entry?.uuid) === String(target.geomId))
      : null;
    if (!geom) continue;
    const pos = Array.isArray(geom.position) ? geom.position : [0, 0, 0];
    bodyUuids.add(target.bodyUuid);
    snapshots.push({
      ...target,
      startLocalPos: [Number(pos[0] ?? 0), Number(pos[1] ?? 0), Number(pos[2] ?? 0)],
    });
  }

  return bodyUuids.size === 1 && snapshots.length > 1 ? snapshots : [];
}

export function computeMultiGeomLocalCentroid(
  snapshots: MultiGeomPositionSnapshot[]
): THREE.Vector3 {
  const centroid = new THREE.Vector3();
  snapshots.forEach((snapshot) => {
    centroid.add(
      new THREE.Vector3(
        snapshot.startLocalPos[0],
        snapshot.startLocalPos[1],
        snapshot.startLocalPos[2]
      )
    );
  });
  return snapshots.length > 0 ? centroid.divideScalar(snapshots.length) : centroid;
}
